<template>
	<vs-row>
		<!-- Affichage du label et de la pagination -->
		<transition name="pop">
			<vs-col class="mb-3 container_label">
				<p v-if="step === 1" class="label_text">Inscrivez-vous !</p>
				<p v-if="step === 2" class="label_text">Démarrer sur Sinao</p>

				<div class="etapes">
					<div class="step" :class="{ 'step-active': step === 1 }"></div>
					<div class="step" :class="{ 'step-active': step === 2 }"></div>
				</div>
			</vs-col>
		</transition>

		<!-- Step 1 : Register -->
		<template v-if="step === 1">
			<vs-col>
				<vs-input
					ref="appName"
					v-model="appName"
					v-validate="'required|min:4'"
					class="w-full mb-3"
					placeholder="Nom de votre entreprise"
					name="appName"
					type="text"
					data-vv-scope="etape1"
					data-vv-delay="300"
					@keydown.enter="validateStep4"
				/>

				<div v-show="errors.has('etape1.appName')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape1.appName") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-input
					v-model="email"
					v-validate="'required|email'"
					class="w-full mb-3"
					placeholder="Email"
					name="email"
					type="email"
					data-vv-scope="etape1"
					data-vv-delay="300"
					@keydown.enter="validateStep1"
				/>

				<div v-show="errors.has('etape1.email')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape1.email") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-input
					v-model="firstname"
					v-validate="'required|alpha_spaces|min:2'"
					class="w-full mb-3"
					placeholder="Prenom"
					name="firstname"
					type="text"
					data-vv-scope="etape1"
					data-vv-delay="300"
					@keydown.enter="validateStep1"
				/>

				<div v-show="errors.has('etape1.firstname')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape1.firstname") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-input
					v-model="lastname"
					v-validate="'required|alpha_spaces|min:2'"
					class="w-full mb-3"
					placeholder="Nom"
					name="lastname"
					type="text"
					data-vv-scope="etape1"
					data-vv-delay="300"
					@keydown.enter="validateStep1"
				/>

				<div v-show="errors.has('etape1.lastname')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape1.lastname") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-input
					v-model="phoneNumber"
					v-validate="'numeric'"
					class="w-full mb-3"
					placeholder="Téléphone (Recommandé)"
					name="phoneNumber"
					type="text"
					data-vv-scope="etape1"
					data-vv-delay="300"
					@keydown.enter="validateStep1"
				/>

				<div v-show="errors.has('etape1.phoneNumber')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape1.phoneNumber") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-row>
					<vs-col vs-w="11" style="padding-left: 0">
						<vs-input
							v-model="password"
							v-validate="'required|min:8'"
							name="password"
							:type="inputPasswordType"
							:danger="
								passwordError.length > 0 ||
								(errors.has('etape1.password') && password && password.length > 0)
							"
							data-vv-scope="etape1"
							class="w-full mb-3"
							placeholder="Mot de passe"
							data-vv-delay="300"
							@keydown.enter="validateStep1"
						/>
					</vs-col>
					<vs-col vs-w="1" style="padding: 0">
						<div class="eyeContainer" @click="toogleInputPasswordType()">
							<vs-icon icon="visibility" color="primary"></vs-icon>
						</div>
					</vs-col>
				</vs-row>

				<div v-show="errors.has('etape1.password') || passwordError.length > 0" class="form_error">
					<strong class="font-semibold">
						{{ errors.first("etape1.password") }}
						{{ passwordError.length > 0 ? passwordError : "" }}
					</strong>
				</div>
			</vs-col>

			<vs-col class="mb-3">
				<p>
					<input
						id="cgu"
						v-model="cgu"
						v-validate="'included:1'"
						type="checkbox"
						name="cgu"
						class="mx-3 checkbox"
						data-vv-scope="etape1"
					/>
					<label for="cgu">
						{{ $t("J’ai lu et j’accepte les") }}
						<a
							href="#"
							class="text-lien"
							@click="openPage('cgu', false)"
							@keydown.enter="openPage('cgu', false)"
						>
							{{ $t("Conditions Générales d’Utilisation") }}
						</a>
					</label>
				</p>

				<div v-show="errors.has('etape1.cgu')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape1.cgu") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-button
					ref="btnStep1"
					:disabled="!password || (errors.items && errors.items.length > 0) || passwordError.length > 0"
					class="vs-con-loading__container bgc-bleu w-full"
					@click="validateStep1"
				>
					Suivant
				</vs-button>
			</vs-col>
		</template>

		<!-- Ste 2 : Pay -->
		<template v-if="step === 2">
			<vs-col class="mb-1">
				<h3 class="mb-3">Étape 2/2 : Paiement</h3>
				<b>Nouveau mode de paiement</b>
			</vs-col>

			<!-- Credit card -->
			<vs-col class="mb-3">
				<!-- Stripe Element -->
				<div id="card-element" ref="card-element" class="vs-inputx vs-input--input normal"></div>
				<div id="card-errors"></div>

				<!--
				<StripeElementCard
					ref="elementRef"
					:element-style="{ border: '1px solid rgba(0, 0, 0, 0.2)' }"
					:classes="{
						base: 'vs-inputx vs-input--input normal',
						focus: 'focus-stripe-card'
					}"
					locale="fr"
					:pk="stripePublicKey"
					:hide-postal-code="true"
					@token="tokenCreated"
				/>
				-->
			</vs-col>

			<vs-col class="mb-3">
				<vs-input
					v-model="creditCardHolder"
					v-validate="'required'"
					class="w-full mb-3"
					placeholder="Nom sur la carte"
					name="creditCardHolder"
					type="creditCardHolder"
					data-vv-scope="etape2"
					data-vv-delay="300"
					@keydown.enter="validateStep2"
				/>

				<div v-show="errors.has('etape2.creditCardHolder')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape2.creditCardHolder") }}</strong>
				</div>
			</vs-col>

			<vs-col class="mb-1">
				<b>Adresse de facturation</b>
			</vs-col>

			<vs-col>
				<vs-input
					v-model="billing.address"
					v-validate="'required'"
					class="w-full mb-3"
					placeholder="Adresse"
					name="address"
					type="address"
					data-vv-scope="etape2"
					data-vv-delay="300"
					@keydown.enter="validateStep2"
				/>

				<div v-show="errors.has('etape2.address')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape2.address") }}</strong>
				</div>
			</vs-col>

			<vs-col vs-type="flex" vs-w="6">
				<vs-input
					v-model="billing.city"
					v-validate="'required'"
					class="w-full mb-3"
					placeholder="Ville"
					name="city"
					type="city"
					data-vv-scope="etape2"
					data-vv-delay="300"
					@keydown.enter="validateStep2"
				/>

				<div v-show="errors.has('etape2.city')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape2.city") }}</strong>
				</div>
			</vs-col>

			<vs-col vs-type="flex" vs-w="6">
				<vs-input
					v-model="billing.postalCode"
					v-validate="'required'"
					class="w-full mb-3"
					placeholder="Code postal"
					name="postalCode"
					type="postalCode"
					data-vv-scope="etape2"
					data-vv-delay="300"
					@keydown.enter="validateStep2"
				/>

				<div v-show="errors.has('etape2.postalCode')" class="form_error">
					<strong class="font-semibold">{{ errors.first("etape2.postalCode") }}</strong>
				</div>
			</vs-col>

			<vs-col>
				<vs-button
					ref="btnStep2"
					:disabled="errors && errors.items && errors.items.length > 0"
					class="vs-con-loading__container bgc-bleu w-full"
					@click="validateStep2"
				>
					Payer
				</vs-button>
			</vs-col>
		</template>
	</vs-row>
</template>

<script>
	import "vue-form-wizard/dist/vue-form-wizard.min.css";
	import { query } from "sinao-corejs";
	import { Validator } from "vee-validate";
	import { mapState } from "vuex";
	import { loadStripe } from "@stripe/stripe-js";

	const dictionary = {
		custom: {
			email: {
				required: "Vous devez entrer un e-mail",
				email: "Vous devez entrer un e-mail valide"
			},
			password: {
				required: "Vous devez entrer un mot de passe",
				min: "Le mot de passe doit contenir au moins 8 caractères"
			},
			cgu: {
				included: "Vous devez accepter les conditions générales d’utilisation"
			},
			firstname: {
				required: "Vous devez entrer un prénom",
				alpha_spaces: "Le prénom ne peut contenir que des lettres ou des espaces",
				min: "Votre prénom doit contenir au moins 2 caractères"
			},
			lastname: {
				required: "Vous devez entrer un nom",
				alpha_spaces: "Le nom ne peut contenir que des lettres ou des espaces",
				min: "Votre nom doit contenir au moins 2 caractères"
			},
			phoneNumber: {
				required: "Vous devez entrer un numéro de téléphone",
				numeric: "Le numéro de téléphone ne doit contenir que des chiffres"
			},
			appName: {
				required: "Veuillez entrer le nom de votre entreprise",
				min: "Votre nom de votre entreprise doit contenir au moins 4 caractères"
			}
		}
	};

	const plans = [
		"price_1HYuzOHnS2nCGsU2V3G8a4Mn",
		"price_1HYuzRHnS2nCGsU2UekZVLYy",
		"price_1HYuzVHnS2nCGsU2YFzxdxHh",
		"prod_I9DQg3NP0PpMMj",
		"prod_I9DQYGQXuyH8G7",
		"prod_I9DQQCcL3Lazug"
	];

	export default {
		name: "RegisterPayment",
		data() {
			this.stripePublicKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY;
			return {
				step: 1,
				stripe: null,
				card: null,
				appName: null,
				appId: null,
				appUrl: null,
				appToken: null,
				email: null,
				password: null,
				firstname: null,
				lastname: null,
				phoneNumber: null,
				cgu: true,
				creditCardHolder: null,
				billing: {
					address: null,
					city: null,
					postalCode: null
				},
				inputPasswordType: "password"
			};
		},
		computed: {
			...mapState(["planId", "couponCode", "utm"]),
			passwordError() {
				if (this.password?.length < 8) return "";

				if (/\s/.test(this.password)) return "Le mot de passe ne doit pas contenir d’espace";

				return "";
			}
		},
		watch: {
			async step(newValue) {
				if (newValue !== 2) {
					return;
				}

				this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);

				if (document.getElementById("card-element")) {
					const elements_card = this.stripe.elements();

					this.card = elements_card.create("card", {
						style: {
							base: {
								fontSize: "16px",
								color: "#32325d"
							}
						},
						hidePostalCode: true
					});

					this.card.mount("#card-element");

					this.setFocus("card-element");

					// Display user input error
					this.card.addEventListener("change", function (event) {
						const displayError = document.getElementById("card-errors");

						if (event.error) {
							displayError.textContent = event.error.message;
						} else {
							displayError.textContent = "";
						}
					});
				}
			}
		},
		async mounted() {
			Validator.localize("fr", dictionary);

			if (!plans.includes(this.planId)) {
				throw new Error("Plan ID is invalid");
			}

			this.setFocus("appName");
		},
		methods: {
			toogleInputPasswordType() {
				this.inputPasswordType = this.inputPasswordType === "password" ? "text" : "password";
			},
			async validateStep1() {
				if (this.passwordError.length > 0) return;

				try {
					const isFormValid = await this.$validator.validate("etape1.*");

					if (isFormValid) {
						this.$vs.loading({
							type: "default",
							color: "var(--white)",
							background: "var(--primary)",
							container: this.$refs.btnStep1.$el,
							scale: 0.5
						});

						this.$refs.btnStep1.$el.disabled = true;

						const { firstname, lastname, email, password, appName } = this;

						const cgu = this.cgu ? 1 : 0;

						const response1 = await this.$store.dispatch("register", {
							firstname,
							lastname,
							email,
							password,
							cgu
						});

						if (response1) {
							window.dataLayer.push({
								sinao_user: response1,
								event: "sinaoregister-user"
							});

							const response2 = await this.$store.dispatch("login", { email, password });

							if (response2) {
								this.appToken = response2?.access_token;

								const response3 = await this.$store.dispatch("createApp", {
									appName,
									token: this.appToken,
									domain: "sinao.app"
								});

								if (response3) {
									window.dataLayer.push({
										sinao_app: response3,
										event: "sinaoregister-app"
									});

									const { url, id } = response3;

									await this.$store.dispatch("updateAppSettings", {
										appId: id,
										token: this.appToken,
										data: { utm: this.utm }
									});

									this.appId = id;
									this.appUrl = url;
									this.step = 2;
								}
							}
						}
					}
				} catch (error) {
					console.log(error);

					this.$vs.dialog({
						type: "alert",
						color: "danger",
						title: "Oups !",
						text: "Une erreur est survenue, veuillez vérifier vos informations et si le problème persiste à contacter le support."
					});
				} finally {
					this.$vs.loading.close(this.$refs.btnStep1.$el);
					this.$refs.btnStep1.$el.disabled = false;
				}
			},
			async validateStep2() {
				try {
					const isFormValid = await this.$validator.validate("etape2.*");

					if (isFormValid) {
						this.$vs.loading({
							type: "default",
							color: "var(--white)",
							background: "var(--primary)",
							container: this.$refs.btnStep2.$el,
							scale: 0.5
						});

						this.$refs.btnStep2.$el.disabled = true;

						const { email, firstname, lastname } = this;
						const { address, city, postalCode } = this.billing;

						const { source, error } = await this.stripe.createSource(this.card, {
							type: "card",
							currency: "eur",
							owner: {
								name: `${firstname} ${lastname}`,
								address: {
									line1: address,
									city,
									postal_code: postalCode
								},
								email
							}
						});

						if (source?.error) {
							throw new Error(source?.error);
						}

						if (source?.id) {
							this.submitPayment(source.id);
							this.goToApp();
						}
					}
				} catch (error) {
					console.log(error);

					this.$vs.dialog({
						type: "alert",
						color: "danger",
						title: "Oups !",
						text: "Une erreur est survenue, veuillez vérifier vos informations et si le problème persiste à contacter le support."
					});
				} finally {
					this.$vs.loading.close(this.$refs.btnStep2.$el);
					this.$refs.btnStep2.$el.disabled = false;
				}
			},
			async submitPayment(sourceId) {
				try {
					await query({
						operationId: "app.subscription.pay",
						params: {
							appId: this.appId
						},
						data: {
							stripe_plan: this.planId,
							stripe_source: sourceId,
							stripe_coupon: this.couponCode
						}
					});
				} catch (error) {
					console.log(error);
				}
			},
			goToApp() {
				window.dataLayer.push({
					event: "sinaoregister-redirect"
				});

				const url = `${this.appUrl}?login=${this.appToken}`;

				if (window.parent) {
					window.parent.location.href = url;
				} else {
					window.location.href = url;
				}
			},
			openPage(path, account = false) {
				const url = account ? process.env.VUE_APP_ACCOUNT_URL : process.env.VUE_APP_WEBSITE_URL;

				window.open(`${url}/${path}`);
			},
			setFocus(input) {
				if (this.$refs[input] && this.$refs[input].$el) {
					this.$refs[input].$el.querySelector("input").focus();
				}
			}
		}
	};
</script>

<style>
	#stripe-element-mount-point {
		border: 1px solid rgba(0, 0, 0, 0.2);
		padding-top: 13px;
	}

	#stripe-element-form {
		height: 45px;
	}

	.eyeContainer {
		cursor: pointer;
		position: absolute;
		right: 0.75rem;
		top: 50%;
		transform: translateY(-50%);
		padding-right: 12px;
		height: 24px;
	}

	.focus-stripe-card {
		border: 1px solid rgba(var(--vs-primary), 1) !important;
		-webkit-box-shadow: 0 3px 10px 0 rgb(0 0 0 / 15%);
		box-shadow: 0 3px 10px 0 rgb(0 0 0 / 15%);
	}

	@font-face {
		font-family: "Asap";
		src: local("Asap Medium"), local("Asap-Medium"),
			url("https://fonts.gstatic.com/s/asap/v11/KFOnCniXp96aw8g99UtvBg.woff2") format("woff2");
		font-style: normal;
		font-weight: 500;
		unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122,
			U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
	body {
		font-family: "Open Sans", sans-serif;
	}
	.register {
		height: 12rem;
	}
	.register_form_container {
		display: grid;
		grid-template-areas: "label label" "champs btn" "checkbox checkbox" "erreur erreur";
		grid-template-columns: 1fr auto;
		width: 100%;
		row-gap: 0.5em;
	}
	.register_form_end {
		display: grid;
		grid-template-areas: "text" "action";
		grid-template-rows: 1fr 1fr;
		height: 100%;
		border-radius: 0.75em;
		text-align: center;
		overflow: hidden;
		transition: background-color 500ms ease-in-out;
		/* box-shadow: 0px 4px 4px 0px #0000001c; */
	}
	.register_text {
		text-align: center;
		font-size: 12px;
	}
	button[name="button"].bgc-bleu,
	.bgc-bleu {
		background-color: var(--primary) !important;
	}
	a.text-lien,
	a.text-lien:visited {
		color: var(--link);
		font-weight: 500;
	}
	.text-vert {
		color: var(--success) !important;
	}
	.checkbox:focus {
		outline: dotted thin;
		outline-offset: 1px;
	}
	.bgc-vert {
		background-color: var(--success) !important;
	}
	.form_end-2 {
		grid-template-rows: 45% 55%;
	}
	.form_end_text {
		grid-area: text;
		color: white;
		font-family: "Asap", sans-serif;
		font-weight: 500;
		font-size: 20px;
		margin: auto;
		padding: 0 50px;
		line-height: 25px;
	}
	.form_end_action {
		grid-area: action;
	}
	.form_error {
		/* grid-area: erreur; */
		background-color: #ffe5e9;
		color: var(--danger);
		width: 100%;
		padding: 0.5em 1em;
		border-radius: 0.5em;
		margin: 0.5em 0;
	}
	.container_label {
		grid-area: label;
		display: flex;
		flex-direction: row;
	}
	.container_champs {
		grid-area: champs;
		display: flex;
		flex-direction: row;
	}
	.container_accountAlreadyExist {
		grid-area: erreur;
	}
	.container_btn {
		grid-area: btn;
		padding-left: 0.75rem;
	}
	.container_checkbox {
		grid-area: checkbox;
		display: grid;
		grid-template-columns: 100%;
		align-items: center;
	}
	.container_mail {
		flex-direction: column;
	}

	.container_step3 {
		width: 30%;
		margin-right: 3.3%;
	}

	.container_step4 {
		width: 30%;
		margin-right: 3.3%;
	}

	@media screen and (max-width: 600px) {
		.container_champs {
			flex-direction: column;
		}
		.container_btn {
			padding: 0;
		}
		.container_mdp {
			width: 100%;
			flex-direction: column;
		}

		.container_step3 {
			width: 100%;
			margin: 0;
			padding-top: 0.5rem;
		}

		.container_step4 {
			width: 100%;
			margin: 0;
			padding-top: 0.5rem;
		}

		.register_form_container {
			grid-template-areas: "label" "champs" "checkbox" "erreur" "btn";
		}
	}
	.vs-button {
		font-weight: 400;
	}
	.vs-input--placeholder.normal {
		top: 6px;
	}
	.loader {
		position: relative;
		width: 100%;
		height: 100%;
	}
	.label_text {
		color: var(--title);
		font-family: "Asap", sans-serif;
		font-weight: 500;
		font-size: 1.1rem;
	}
	.etapes {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 0 0.75rem 0 auto;
	}
	.step {
		display: block;
		width: 1em;
		height: 1em;
		background-color: var(--border);
		border-radius: 50%;
		margin: 0.25em;
	}
	.step-active {
		background-color: var(--primary);
		border: solid var(--white) 0.2em;
		box-shadow: #00000044 0 0.1em 0.25em;
	}

	/* transition entrante du label et de la checkbox */
	.pop-enter {
		max-height: 0em;
		opacity: 0;
	}
	.pop-enter-active {
		transition: max-height 0.5s 0s ease-in-out, opacity 0.25s 0.15s ease-in;
	}
	.pop-enter-to {
		max-height: 5em;
		opacity: 1;
	}

	/* transition entre step 5 et 6 */
	.fade-between-enter {
		opacity: 0;
	}
	.fade-between-active {
		transition: opacity 0.5s ease-in-out;
	}
	.fade-between-enter-to {
		opacity: 1;
	}
	.fade-between-leave {
		opacity: 1;
	}
	.fade-between-leave-to {
		opacity: 0;
	}
</style>
